module.exports = __webpack_public_path__ + "media/coralcity_small.2505915c.mp4";